import { discoveryConfig } from "./config";

/** Market date first, then fixed clock window. No score can cross either. */
export function classTemporalKey(
  start: string,
  timeZone = "Asia/Kolkata",
): string {
  const date = new Date(start);
  if (!Number.isFinite(date.getTime())) return "9999-99-99:9999";
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);
  const get = (name: string) =>
    parts.find((p) => p.type === name)?.value ?? "00";
  const bucket = Math.floor(
    (Number(get("hour")) * 60 + Number(get("minute"))) /
      discoveryConfig.classTimeWindowMinutes,
  );
  return `${get("year")}-${get("month")}-${get("day")}:${String(bucket).padStart(4, "0")}`;
}
export function compareClassTime(
  a: { slots: { startIso: string }[]; timeZone?: string },
  b: { slots: { startIso: string }[]; timeZone?: string },
): number {
  return classTemporalKey(a.slots[0]?.startIso ?? "", a.timeZone).localeCompare(
    classTemporalKey(b.slots[0]?.startIso ?? "", b.timeZone),
  );
}
